import React, { useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button, Space, Typography } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import DataScienceJobsTab from "./DataScienceJobsTab";
import AdminValidation from "../../components/adminvalidation/AdminValidation";
import JobOriginIndicator from "./JobOriginIndicator";
import { getJobTypeConfig, isKnownJobType } from "./dataScienceJobTypes";

const { Title } = Typography;

const DataScienceJobsMain: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { jobType } = useParams<{ jobType: string }>();

  const jobConfig = useMemo(
    () => (jobType ? getJobTypeConfig(t, jobType) : undefined),
    [jobType, t]
  );

  if (!jobType || !isKnownJobType(jobType) || !jobConfig) {
    navigate("/admin/datasciencejobs", { replace: true });
    return null;
  }

  return (
    <AdminValidation>
      <div style={{ padding: "24px" }}>
        <div style={{ marginBottom: "24px" }}>
          <Space direction="vertical" size={8}>
            <Button
              type="link"
              icon={<ArrowLeftOutlined />}
              onClick={() => navigate("/admin/datasciencejobs")}
              style={{ paddingLeft: 0 }}
            >
              {t("DataScienceJobs-BackToDashboard")}
            </Button>
            <Space align="center">
              <Title level={2} style={{ marginBottom: 0 }}>
                {jobConfig.displayName}
              </Title>
              <JobOriginIndicator
                origin={jobConfig.origin}
                size={18}
                tooltipTitle={jobConfig.label}
              />
            </Space>
            <Typography.Text type="secondary">
              {jobConfig.description}
            </Typography.Text>
          </Space>
        </div>

        <DataScienceJobsTab
          jobType={jobConfig.jobType}
          jobOrigin={jobConfig.origin}
          displayName={jobConfig.displayName}
          description={jobConfig.description}
        />
      </div>
    </AdminValidation>
  );
};

export default DataScienceJobsMain;
